export default function svgHandler() {
	const tooltipZones = document.querySelectorAll('.js-svg-map svg path');
	const svgContainer = document.querySelector('.js-svg-map');

	if (!tooltipZones.length || !svgContainer) {
		return;
	}

	const handleTooltip = (zone, tooltip) => {
		const containerRect = svgContainer.getBoundingClientRect();
		const centerX = containerRect.width / 2;
		const centerY = containerRect.height / 2;

		tooltip.style.left = `${centerX}px`;
		tooltip.style.top = `${centerY}px`;
		tooltip.style.transform = 'translate(-50%, -50%)';
		tooltip.style.position = 'absolute';
		tooltip.style.opacity = '1';
		tooltip.style.visibility = 'visible';
		tooltip.style.pointerEvents = 'all';
		tooltip.style.height = 'auto';

		zone.style.fillOpacity = '0.5';

		document.querySelectorAll('.js-svg-tooltip').forEach((otherTooltip) => {
			if (otherTooltip !== tooltip) {
				otherTooltip.style.opacity = '0';
				otherTooltip.style.visibility = 'hidden';
				otherTooltip.style.height = '0';
				otherTooltip.style.pointerEvents = 'none';
			}
		});

		tooltipZones.forEach((otherZone) => {
			if (otherZone !== zone) {
				otherZone.style.fillOpacity = '';
			}
		});
	};

	const handleMouseOut = (event, tooltip, zone) => {
		if (!tooltip.contains(event.relatedTarget) && !zone.contains(event.relatedTarget)) {
			tooltip.style.opacity = '0';
			tooltip.style.visibility = 'hidden';
			tooltip.style.pointerEvents = 'none';
			tooltip.style.height = '0';
			zone.style.fillOpacity = '';
		}
	};

	tooltipZones.forEach((zone) => {
		const zoneID = zone.getAttribute('id');
		const tooltip = document.querySelector(`.js-svg-tooltip[data-id="tooltip-${zoneID}"]`);
		const closeButton = tooltip.querySelector('.js-tooltip-close');

		if (!tooltip) {
			console.warn(`Tooltip for zone ${zoneID} not found.`);

			return;
		}

		tooltip.style.pointerEvents = 'none';

		if (window.matchMedia('(min-width: 768px)').matches) {
			zone.addEventListener('mouseover', () => handleTooltip(zone, tooltip));
			zone.addEventListener('mouseout', (event) => handleMouseOut(event, tooltip, zone));

			zone.addEventListener('click', () => {
				const link = tooltip.getAttribute('data-tooltip-link');
				if (link) {
					window.open(link, '_self');
				}
			});
		} else {
			tooltip.style.height = '0';
			zone.addEventListener('click', (event) => {
				event.stopPropagation();
				handleTooltip(zone, tooltip);
			});

			document.addEventListener('click', (event) => {
				if (!tooltip.contains(event.target)) {
					handleMouseOut(event, tooltip, zone);
				}
			});

			if (closeButton) {
				closeButton.addEventListener('click', (event) => {
					event.stopPropagation();
					handleMouseOut(event, tooltip, zone);
				});
			}
		}

		tooltip.addEventListener('click', (event) => {
			event.stopPropagation();
		});
	});
}